import { Slider as MuiSlider } from "@mui/material";

import "./Slider.less";

/**
 * Disabled state will be styled at a later date
 */
export const Slider = MuiSlider;

export default MuiSlider;
export type { SliderComponent } from "@mui/material";
